module.exports = __webpack_public_path__ + "static/HeartIcon-9b1be997b9caa046982e0170fa19bcea.ico";